import React from "react";
function ShadowContent({ html }) {
  const ref = React.useRef(null);

  React.useEffect(() => {
    if (!ref.current) return;
    const shadow =
      ref.current.shadowRoot || ref.current.attachShadow({ mode: "open" });
    shadow.innerHTML = html;
  }, [html]);

  return <shadow-wrapper ref={ref} />;
}

export default ShadowContent;
